import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../../../App.css';
import { styled } from '../../../../components/styled';
import SpText from '../../../../components/atoms/SpText';
import SpButton from '../../../../components/atoms/SpButton';
import { SpTable, SpTableCell, SpTableRow } from '../../../../components/bundles/SpTable';
import moment from 'moment';
import { TableCell } from '@material-ui/core';
import { withSnackbar } from '../../../../components/atoms/SpSnackBar';
import { findStationById } from '../../../../models/actions/Stations';
import { findRentsByStationId } from '../../../../models/actions/Rents';
import { sendEmail } from '../../../../models/actions/UtilsActions';
import { isMobile } from 'react-device-detect';
import { UserSessionContext } from '../../../../App';

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const StationOpenRents = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [rentsList, setRentsList] = useState([]);
  const { stationId } = useParams();
  const history = useHistory();
  const { authData, setAuthData } = useContext(UserSessionContext);
  const { setDialogUserPNOpen, setDialogEndRent, refresh } = props;

  const { register, control, error, getValues, setValue, handleSubmit, reset } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const fetchData = async () => {
    if (stationId) {
      try {
        const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
        responseStation && setCurrentStation(responseStation);
        const response = await findRentsByStationId({ id_station: stationId }, authData.accessToken);
        if (response) {
          const filteredData = response.filter((elem) => elem.rent.status == 'open');
          setRentsList(filteredData);
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  const sendMailToUser = async (data) => {
    try {
      const emailSentResponse = await sendEmail({ ...data.user, subject: 'Controlla il tuo noleggio attivo!', content: 'Devi controllare il tuo noleggio attivo della bike: ' + data.bike?.code }, authData.accessToken);
      emailSentResponse && props.snackbarShowMessage('Email inviata con successo!');
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    fetchData();
  }, [refresh]);

  const headCells = [
    {
      id: 'station',
      numeric: false,
      disablePadding: false,
      label: 'stazione',
      isAction: false
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email utente',
      isAction: false
    },
    {
      id: 'data inizio',
      numeric: false,
      disablePadding: false,
      label: 'Data inizio',
      isAction: false
    },
    {
      id: 'azioni',
      numeric: false,
      disablePadding: false,
      label: '',
      isAction: true
    }
  ];

  //rendering the profile editing form
  const RentRow = ({ row, rowKey, index, handleSelectedClick }) => {
    return (
      <>
        <SpTableRow
          role="checkbox"
          id={row?.id}
          tabIndex={index}
        >
          <SpTableCell>
            <SpText variant="tableText">{row.station?.name}</SpText>
          </SpTableCell>
          <SpTableCell>
            <SpText variant="tableText">{row.user?.email}</SpText>
          </SpTableCell>
          <SpTableCell>
            <SpText variant="tableText">{row.rent.start_date && moment(row.rent.start_date).format('DD/MM/yyyy hh:mm')}</SpText>
          </SpTableCell>
          <TableCell
            align={'right'}
            style={{
              padding: 0,
              verticalAlign: 'center',
              borderBottom: 0
            }}
          >
            <SpButton
              text="Chiama"
              variant={'tableAction'}
              onClick={() => setDialogUserPNOpen({ user: row.user, status: true })}
            />
            <SpButton
              text="Manda Notifica Mail"
              variant={'tableAction'}
              onClick={() => sendMailToUser({ user: row.user, bike: row.bike })}
            />
            <SpButton
              text="Restituisci forzatamente"
              variant={'tableAction'}
              onClick={() => setDialogEndRent({ rent: row.rent, station: row.station, bike: row.bike, status: true })}
            />
          </TableCell>
        </SpTableRow>
      </>
    );
  };

  return (
    <div style={{ padding: 8 }}>
      <SpTable
        pagination={true}
        headCells={headCells}
        rows={rentsList}
        rowKey="id"
        padding={false}
        notCheckable={false}
        tableContainerMaxHeight={isMobile ? 'calc(100vh - 300px)' : 'calc(100vh - 320px)'}
      >
        <RentRow />
      </SpTable>
    </div>
  );
};

export default withSnackbar(StationOpenRents);
